import React, { useContext } from 'react';

interface IAddCoverDialogContext {
  openDialog: (callback: any, cover: any) => void;
}

export const AddCoverDialogContext = React.createContext<Partial<IAddCoverDialogContext>>({
  openDialog: () => {},
});

export const useAddCoverDialogContext = () => useContext(AddCoverDialogContext);
